import angular from 'angular';
import components from './components';

export default angular.module('blueStoneSubmission.scenes', [components]).name;
